export default "__VITE_ASSET__DgX3MNX$__"